import {
  reduxLoadStateLocalStorage,
  reduxPersistStateLocalStorage,
  storeReducerDisplay,
} from "@package/ui-redux";
import { storeReducerWall } from "@package/ui-wall-engine";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector, useStore } from "react-redux";
import { REDUX_SAVE_DEBCOUNCE_MS } from "../constants/contants";
import { sha } from "../version";
import { reducerAnalyticsOverviewBar } from "./slices/slice-analytics-overview-bar";
import { reducerItemGrid } from "./slices/slice-item-grid";
import { reducerMedia } from "./slices/slice-media";
import { reducerScheduler } from "./slices/slice-scheduler";

export const store = configureStore({
  reducer: combineReducers({
    ...storeReducerDisplay,
    ...storeReducerWall,
    analyticsOverviewBar: reducerAnalyticsOverviewBar,
    itemGrid: reducerItemGrid,
    media: reducerMedia,
    scheduler: reducerScheduler,
  }),
  preloadedState: reduxLoadStateLocalStorage(sha),
});

reduxPersistStateLocalStorage(store, sha, REDUX_SAVE_DEBCOUNCE_MS);

export type AppStore = typeof store;
export type AppState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
export const useAppStore: () => AppStore = useStore;
